interface Options {
  isNegative?: boolean;
  removeCurrencySymbol?: boolean;
}

export function convertToCurrency(value: number): string {
  const fractionalValue = value / 100;
  const formattedValue = Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(fractionalValue);

  return formattedValue;
}

export function removeCurrencySign(value: string | number): string {
  return String(value)
    .replace(/\s|R\$/g, '')
    .replace(/^-(?=\d)/, '-')
    .trim();
}

export function identifyNegativeValue(value: string | number) {
  const regex = /[-]+/g;

  return regex.test(String(value));
}

export function removeNegativesign(value: string | number) {
  const regex = /^-\s*/;

  const currencyWithoutNegativeSign = String(value).replace(regex, '').trim();

  return currencyWithoutNegativeSign;
}

function formatValueWithOptions(value: string, options?: Options): string {
  let formattedValue = value;
  const isDefaultNegative = identifyNegativeValue(formattedValue);

  if (options || isDefaultNegative) {
    const { isNegative, removeCurrencySymbol } = options || {};

    const shouldAddNegativeSign =
      isNegative === true || (isNegative === undefined && isDefaultNegative);

    // must always remove the dafault negative
    formattedValue = removeNegativesign(formattedValue);

    formattedValue = (shouldAddNegativeSign ? '- ' : '') + formattedValue;

    formattedValue = removeCurrencySymbol
      ? removeCurrencySign(formattedValue)
      : formattedValue;
  }

  return formattedValue;
}

export function integerToCurrency(
  value: number = 0,
  options?: Options
): string {
  let formattedValue = '';

  formattedValue = convertToCurrency(value);
  formattedValue = formatValueWithOptions(formattedValue, options);

  return formattedValue;
}
